import React from 'react';
import { Link } from 'react-router-dom';
import { FaRegCalendar, FaRegEye, FaArrowLeft } from 'react-icons/fa';
import { getImageUrl } from '../config';
import { categoryLabel, categoryIcon } from '../constants';
import '../styles/ArticleCard.css';

const fmtDate = (d) => {
  if (!d) return '';
  try {
    return new Date(d).toLocaleDateString('ar-DZ', { year: 'numeric', month: 'long', day: 'numeric' });
  } catch (e) {
    return '';
  }
};

const ArticleCard = ({ article }) => {
  const title = article.titleAr || article.title || '';
  const body = article.contentAr || article.content || '';
  const excerpt = body.length > 130 ? body.substring(0, 130).trim() + '…' : body;
  const image = getImageUrl(article.image);

  return (
    <article className="article-card">
      <Link to={'/articles/' + article._id} aria-label={title}>
        <div className="article-image">
          {image ? (
            <img src={image} alt="" loading="lazy" />
          ) : (
            /* no picture on file - a soft, drawn stand-in instead */
            <span className="card-placeholder" aria-hidden="true">{categoryIcon(article.category)}</span>
          )}
          <span className="article-category">{categoryLabel(article.category)}</span>
          {article.featured && <span className="featured-badge">مميز</span>}
        </div>

        <div className="article-content">
          <h3 className="article-title">{title}</h3>
          <p className="article-excerpt">{excerpt}</p>

          <div className="article-meta">
            <span className="meta-item">
              <FaRegCalendar aria-hidden="true" />
              <span>{fmtDate(article.createdAt)}</span>
            </span>
            <span className="meta-item">
              <FaRegEye aria-hidden="true" />
              <span>{article.views || 0} مشاهدة</span>
            </span>
          </div>

          <span className="read-more">
            اقرئي المزيد <FaArrowLeft aria-hidden="true" />
          </span>
        </div>
      </Link>
    </article>
  );
};

export default ArticleCard;
